import React, { useEffect, useState } from 'react';
import classes from "./OtpPage.module.css";
import Header from '../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';
import { SendOtpAPI, VerifyOtpAPI } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import SmallLoader from '../components/Loaders/SmallLoader';
import SubLayout from '../components/SubLayout';

const OtpPage = () => {

    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(120);
    const navigate = useNavigate();
    const [msisdn, setMsisdn] = useState("");
    const [extRef, setExtRef] = useState(null);
    const [resend, setResend] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [autoRenewal, setAutoRenewal] = useState(false);
    const location = useLocation();
    const { t } = useTranslation();

    const dispatch = useDispatch();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setAutoRenewal(location?.state?.autoRenewal);
        }
        else {
            navigate("/");
        }
    }, [location]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);
            const response = await VerifyOtpAPI(msisdn, otp);

            setLoading(false);
            navigate("/confirmation", {
                state: {
                    msisdn: msisdn,
                    extRef: extRef,
                    autoRenewal: autoRenewal
                }
            })
        } catch (error) {
            setLoading(false);
            if (error?.response?.status == 400) {
                toast.error(t("88"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    const resendOtpHandler = async () => {

        try {
            setResendLoading(true);

            const response = await SendOtpAPI(msisdn);
            setTimer(120);
            setResendLoading(false);
            if (response?.data?.status == 1) {
                setResend(true);
                setOtp("");
                toast.success(t("89"));
            }
            else {
                toast.error(t("87"));
            }
        } catch (error) {
            setResendLoading(false);
            toast.error(t("86"));
        }
    }

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, []);

    useEffect(() => {
        if (timer <= 0) {
            navigate("/");
        }
    }, [timer]);

    return (
        <>
            <Header />
            <SubLayout>

                {/* <div className={classes.container}> */}
                <div className={classes.otp_description}>
                    <h2 className={classes.title}>{t("67")}</h2>
                    <p className={classes.text}>
                        {t("68")} {resend && t("71")} {t("69")}
                        <span className={classes.bold}> +240 {msisdn} </span>
                        {t("70")}
                    </p>
                </div>

                <div className={classes.otp_input_container}>
                    <OTPInput
                        value={otp}
                        shouldAutoFocus
                        onChange={setOtp}
                        numInputs={4}
                        renderSeparator={<span className={classes.gap}></span>}
                        renderInput={(props) => (
                            <input {...props} type="number" className={classes.input_box} />
                        )}
                    />
                </div>

                <div className={classes.time_container}>
                    <p className={classes.time_text}>{t("72")} {timer} {t("73")}</p>
                </div>

                {(loading || resendLoading) ? <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                    <SmallLoader />
                </div> : (
                    <div className={classes.btn_container}>
                        <button
                            type="button"
                            className={classes.confirm_btn}
                            disabled={loading}
                            onClick={handleFormSubmission}
                        >
                            {t("74")}
                        </button>
                        <button
                            type="button"
                            className={classes.resend_btn}
                            disabled={resendLoading}
                            onClick={resendOtpHandler}
                        >
                            {t("75")}
                        </button>
                    </div>
                )}
                {/* </div> */}
            </SubLayout>

        </>
    )
}

export default OtpPage